import Filter from "features/view/components/Filters/Filter";
import Input from "components/form/Input/Input";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "hooks/useQuery";

const TermSearch = () => {
  const query = useQuery();
  const [ terms, setTerms ] = useState(query.get('search') || '');
  const history = useHistory();
  const location = useLocation();
  const searchRef = useRef();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setTerms(searchParams.get('search') || '');
  }, [ location ]);

  const handleKeyDown = (event) => {
    if (event.code === "Enter") {
      performSearch(terms);
    }
  }

  const performSearch = (terms) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('search', terms);
    searchParams.delete('page');
    history.push('?' + searchParams.toString());
  }

  const handleChangeTerms = (event) => {
    setTerms(current => event.target.value);
    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }
    searchRef.current = setTimeout(() => performSearch(event.target.value), 750);
  }

  return (
    <Filter title="Trefwoord">
      <Input type="text" placeholder="Bijv. naam, wandelen, schilder gevraagd…"
             onChange={ handleChangeTerms }
             onKeyDown={ handleKeyDown }
             value={ terms }
             autoComplete={ `off` }/>
    </Filter>
  )
}

export default TermSearch;
